import "./AdminUserCard.css";
import {Infinity, PersonCircle} from "react-bootstrap-icons";
import {AccountTier, AdminUser} from "../../RequestsProvider/RequestProvider";
import React, {useEffect, useState} from "react";
import moment from "moment/moment";

interface Props {
    user: AdminUser;
    accountTier: AccountTier
    disabled?: boolean
}

export const AdminUserCard = ({user,accountTier, disabled}: Props) => {

    const [offline, setOffline] = useState(false)
    const [online, setOnline] = useState(false)
    const [lastUpdate, setLastUpdate] = useState<any>()
    const [status, setStatus] = useState("")

    const _setStatus = ()=>{
        if(!user.emailVerified){
            setStatus('E-Mail Verifizierung')
            return
        }
        if(user.isAuthenticated === 'false'){
            if(user.qrCode){
                setStatus('QR-Code steht bereit')
                return
            }else{
                setStatus('Bot muss vom Admin zur Verfügung gestellt werden')
            }
        }else{
            setStatus('Bot läuft')
            setOnline(true)
        }
    }
    const calcTotalTranskriptionUsed= ()=>{
        console.log(user)
        if(accountTier.transcriptionLimit){
            return (user.total_duration / accountTier.transcriptionLimit) * 100
        }else{
            return 100
        }
    }
    useEffect(() => {

        _setStatus()
        setLastUpdate(moment(user.updatedAt).format('DD.MM.YYYY HH:mm'))

        console.log(accountTier)
        const updatedAt = new Date(user.updatedAt)
        const now = new Date()

        const diffMs = now.getTime() - updatedAt.getTime()
        const fifteenMinutes = 15 * 60 * 1000
        if (diffMs > fifteenMinutes) {
            setOffline(true)
        } else {
            setOffline(false)
        }

        if (!user.emailVerified) {
            setOffline(false)
        }

    }, []);
    return (
        <a href={!disabled ? "path" : "#"}
           className={`m-2 border-custom position-relative ${disabled ? 'disabled' : null} ${offline ? 'admin-offline' : online? 'admin-online': null}`}>

            <div className="row mb-4">
                <div className="col-6 d-flex align-items-center">
                    <div className="row mx-2">
                        <div className="col-12"><small className={`text-muted`}>last update: </small></div>
                        <div className="col-12"><small className={`text-muted`}>{lastUpdate?.toString()}h</small></div>
                    </div>
                </div>
                <div className="col-6 d-flex justify-content-end align-items-center mt-2">
                    <small className={`text-muted mx-1`}>{accountTier.tierName.toUpperCase()}</small>

                    {user.profilePictureURL ? <div className="d-flex align-items-center">
                        <div className="circle-colored-admin">
                            <img src={user.profilePictureURL} alt=""
                                 className="img-fluid rounded-circle"/>
                        </div>
                    </div> : <PersonCircle
                        className={`m-1 ${disabled ? 'color-disabled' : 'text-secondary'} ${offline ? 'admin-offline-text' : online? 'admin-online-text': null}`}
                        size={30}/>}

                </div>
            </div>
            <div className="row m-2 mb-3">
                <div className="col-12">
                    <h5 className={`${offline ? 'admin-offline-text' : online ? 'admin-online-text' : status === 'E-Mail Verifizierung' ? 'text-muted' : null}`}>{user.name}</h5>
                </div>
                <div className="col-12 m-0 text-truncate">
                    <p className={"description"}>{user.email}</p>
                </div>
                <div className="col-12 m-0 text-truncate">
                    <p className={"description"}>Status: {status}</p>
                </div>

                {status === 'Bot läuft' ? <div className="position-absolute bottom-0 start-50 translate-middle-x p-0">
                    <small className={'mx-3 text-muted'}>Transkription {Math.round(user.total_duration)} / {accountTier.transcriptionLimit? accountTier.transcriptionLimit : <Infinity className={""} size={10}/>}</small>
                    <div className={`progress bg-none bg-danger-admin ${calcTotalTranskriptionUsed() === 100 && !accountTier.transcriptionLimit? 'opacity-0' : null}`} aria-label="transcription usage" style={{height: '3px'}}>
                        <div className={`progress-bar ${calcTotalTranskriptionUsed() < 100? 'bg-success': 'bg-danger-admin'}`} style={{width: calcTotalTranskriptionUsed()+'%'}}></div>
                    </div>
                </div> : null}
            </div>
        </a>
    );
};
